import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { store } from "./store";
import { i18n } from "./locales";
import Tooltip from "primevue/tooltip";
import "./registerServiceWorker";
import "./config/firebase";
const app = createApp(App);
app.use(i18n);
app.directive("tooltip", Tooltip);
//primevue
import componentsPrimeVue from "./primevue";
componentsPrimeVue.forEach(cop => {
  app.component(cop.name, cop.component);
});
import CustomComponent from "./components/index";
import LayoutService from "./services/layout.service";
CustomComponent.forEach(cop => {
  app.component(cop.name, cop.component);
});
app.provide("layoutService", LayoutService);
app
  .use(store)
  .use(router)
  .mount("#app");
